type RegionIdentity = { id: string };

type LoadRegionSessionOptions<TRegion extends RegionIdentity> = {
  regionId: string | null;
  retrieveRegion: (regionId: string) => Promise<TRegion | undefined>;
  listRegions: () => Promise<TRegion[]>;
};

const isNotFoundError = (error: unknown) =>
  typeof error === "object" && error !== null && "status" in error && error.status === 404;

export const loadRegionSession = async <TRegion extends RegionIdentity>({
  regionId,
  retrieveRegion,
  listRegions,
}: LoadRegionSessionOptions<TRegion>) => {
  const loadDefaultRegion = async () => (await listRegions())[0];

  if (!regionId) return loadDefaultRegion();

  let region: TRegion | undefined;

  try {
    region = await retrieveRegion(regionId);
  } catch (error) {
    if (!isNotFoundError(error)) throw error;
    return loadDefaultRegion();
  }

  if (!region) return loadDefaultRegion();

  return region;
};
